import { render, staticRenderFns } from "./SupplierInventoryList.vue?vue&type=template&id=9b2d834c&scoped=true"
import script from "./SupplierInventoryList.vue?vue&type=script&lang=js"
export * from "./SupplierInventoryList.vue?vue&type=script&lang=js"
import style0 from "./SupplierInventoryList.vue?vue&type=style&index=0&id=9b2d834c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2d834c",
  null
  
)

export default component.exports